"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMultiColumnItem;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AbstractElement = _interopRequireDefault(require("../elements/AbstractElement"));

var HORIZONTAL_ALIGNMENT_TYPES = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
};
var VERTICAL_ALIGNMENT_TYPES = {
  top: 'private-multicolumn--align-top',
  middle: 'private-multicolumn--align-middle',
  bottom: 'private-multicolumn--align-bottom'
};

var getTitleText = function getTitleText(titleText) {
  return _react.default.createElement(_AbstractElement.default, {
    className: "private-multicolumn__item__title"
  }, titleText);
};

function UIMultiColumnItem(props) {
  var children = props.children,
      className = props.className,
      horizontalAlign = props.horizontalAlign,
      titleText = props.titleText,
      verticalAlign = props.verticalAlign,
      width = props.width,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "horizontalAlign", "titleText", "verticalAlign", "width"]);
  var renderedTitle = titleText ? getTitleText(titleText) : null;
  return _react.default.createElement("div", (0, _extends2.default)({}, other, {
    className: (0, _classnames.default)('private-multicolumn__item', 'has--vertical-spacing', HORIZONTAL_ALIGNMENT_TYPES[horizontalAlign], VERTICAL_ALIGNMENT_TYPES[verticalAlign], className),
    style: {
      width: width
    }
  }), renderedTitle, children);
}

UIMultiColumnItem.displayName = 'UIMultiColumnItem';
UIMultiColumnItem.propTypes = {
  children: _propTypes.default.node,
  horizontalAlign: _propTypes.default.oneOf(Object.keys(HORIZONTAL_ALIGNMENT_TYPES)),
  titleText: _propTypes.default.node,
  verticalAlign: _propTypes.default.oneOf(Object.keys(VERTICAL_ALIGNMENT_TYPES)),
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
UIMultiColumnItem.defaultProps = {
  verticalAlign: 'middle'
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/layout/UIMultiColumnItem.js
// module id = 845
// module chunks = 5 6